module.exports = __webpack_public_path__ + "img/logo-sm.bdfa2b47.png";